module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album_large_lv-a7cc8bbea55192c4a455e98af7ff7b3e.png";